import {Component, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {DirectusTooltipComponent} from '../../../../directus-tooltip/directus-tooltip.component';
import {AppDatePipe} from '@frontend/shared';
import {TimeframeDisplayVM} from '../timeframe-display/timeframe-display.types';

@Component({
  selector: 'app-timeframe-planned-dates-card',
  imports: [TranslocoPipe, DirectusTooltipComponent, AppDatePipe],
  templateUrl: './timeframe-planned-dates-card.component.html',
})
export class TimeframePlannedDatesCardComponent {
  readonly config = input.required<TimeframeDisplayVM>();
}
